import script from "./NoticeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeModal.vue?vue&type=script&setup=true&lang=js"

import "./NoticeModal.vue?vue&type=style&index=0&id=75947d68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75947d68"]])

export default __exports__